function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.date.to-iso-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useState } from 'react';
import { Box, Button, Checkbox, DatePicker, Dialog, FileUpload, Flex, HelpText, MultiCombobox, Notice, RadioGroup, Select, Switch, Text, TextInput, createDatePickerValidator, useToasts } from '@applyboard/crystal-ui';
import { MagicWandFillIcon, SearchOutlineIcon } from '@applyboard/ui-icons';
import { monolithEmailValidation, useEventTracker } from '@applyboard/ui-utils';
import { useMarkets } from "../../data/markets";
import { useExtractPassportInfo } from "../../data/passport";
import { Field, useFieldValues, useSetFieldValues } from "./AddNewStudentDialogForm";
import { MAX_PASSPORT_INPUT_LIMIT, MIN_PHONE_NUMBER_LENGTH, SERVICE_OF_INTEREST_DATA } from "./const";
import { validateMaxCharacterLength } from "./util";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Fragment as _Fragment } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { createElement as _createElement } from "@emotion/react";
var CustomReferralField = function CustomReferralField() {
  var _useFieldValues = useFieldValues(['leadSource']),
    leadSource = _useFieldValues.leadSource;
  return leadSource === 'other' ? _jsx(Field, {
    as: TextInput,
    name: "customLeadSource",
    label: "Custom Referral Source",
    required: leadSource === 'other' ? 'Since you entered a referral source of other, you must provide a custom value for the referral source' : false,
    validate: function validate(leadSource) {
      return validateMaxCharacterLength(leadSource, 'Referral source');
    }
  }) : null;
};
var StudentConsentErrorLabel = function StudentConsentErrorLabel(_ref) {
  var hasClickedSubmit = _ref.hasClickedSubmit;
  var _useFieldValues2 = useFieldValues(['didStudentConsent']),
    didStudentConsent = _useFieldValues2.didStudentConsent;
  return !didStudentConsent && hasClickedSubmit ? _jsx(HelpText, {
    showIcon: true,
    intent: "negative",
    children: "Confirmation is required."
  }) : null;
};
export var AddNewStudentDialog = function AddNewStudentDialog(_ref2) {
  var _ref2$isOpen = _ref2.isOpen,
    isOpen = _ref2$isOpen === void 0 ? false : _ref2$isOpen,
    setIsOpen = _ref2.setIsOpen,
    countriesOfCitizenshipList = _ref2.countriesOfCitizenshipList,
    leadStatusList = _ref2.leadStatusList,
    leadSourcesList = _ref2.leadSourcesList,
    _ref2$isAdmin = _ref2.isAdmin,
    isAdmin = _ref2$isAdmin === void 0 ? false : _ref2$isAdmin,
    _ref2$isSubmittingStu = _ref2.isSubmittingStudentProfile,
    isSubmittingStudentProfile = _ref2$isSubmittingStu === void 0 ? false : _ref2$isSubmittingStu,
    hasFormError = _ref2.hasFormError;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasClickedSubmit = _useState2[0],
    setHasClickedSubmit = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showAutofillUpload = _useState4[0],
    setShowAutofillUpload = _useState4[1];
  var _useExtractPassportIn = useExtractPassportInfo(),
    extractPassportInfo = _useExtractPassportIn.extractPassportInfo;
  var setFieldValues = useSetFieldValues();
  var _useFieldValues3 = useFieldValues(['passportExpiryDate', 'passportNumber']),
    passportExpiryDateFieldValue = _useFieldValues3.passportExpiryDate,
    passportNumberFieldValue = _useFieldValues3.passportNumber;
  var toasts = useToasts();
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var _useMarkets = useMarkets(),
    markets = _useMarkets.markets;
  var today = new Date();
  var oneHundredYearsAgo = new Date(today.setFullYear(today.getFullYear() - 100));
  var twentyFiveYearsFromNow = new Date(new Date().setFullYear(new Date().getFullYear() + 25));
  var birthDateConstraints = {
    min: oneHundredYearsAgo,
    max: new Date()
  };
  var passportExpiryDateConstraints = {
    min: oneHundredYearsAgo,
    max: twentyFiveYearsFromNow
  };
  var uploadFileCallback = function uploadFileCallback(file, params) {
    extractPassportInfo({
      file: file
    }, {
      onSuccess: function onSuccess(response) {
        if (response && Object.keys(response).length) {
          setFieldValues({
            firstName: response.name,
            lastName: response.surname,
            birthDate: new Date("".concat(response.birth_date, " ").concat(getBrowserTimezone(new Date(response.birth_date)))).toISOString(),
            gender: response.sex && response.sex.toLowerCase() == 'm' ? 'male' : 'female',
            countryOfCitizenship: response.nationality && response.nationality.substr(0, 2).toUpperCase(),
            passportNumber: response.document_number,
            passportExpiryDate: new Date("".concat(response.expiry_date, " ").concat(getBrowserTimezone(new Date(response.expiry_date)))).toISOString()
          });
          toasts.positive('File successfully scanned. Appropriate fields autofilled.');
          trackEvent({
            data: {
              firstName: !!response.name,
              lastName: !!response.surname,
              birthDate: !!response.birth_date,
              gender: !!response.sex,
              countryOfCitizenship: !!response.nationality,
              passportNumber: !!response.document_number,
              passportExpiryDate: !!response.expiry_date
            },
            event: 'Passport OCR - Upload Successful',
            group: 'Add New Student Modal'
          });
        } else {
          toasts.warning('No passport information found. Please make sure photo is clearly framed and in focus.');
        }
        params.onSuccess(response.document_number || '');
      },
      onError: function onError() {
        params.onError("The uploaded file may not contain any relevant information. Please make sure it\u2019s the right document and try again or fill out the form manually instead.");
        trackEvent({
          event: 'Passport OCR - Upload Unsuccessful',
          group: 'Add New Student Modal'
        });
      }
    });
  };
  useEffect(function () {
    var _document$getElementB;
    (_document$getElementB = document.getElementById('ab-ansm-dialog-content')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.scrollIntoView({
      behavior: 'smooth'
    });
  }, [hasFormError]);
  return _jsx(Dialog, {
    open: isOpen,
    onOpenChange: function onOpenChange(newOpenState) {
      setIsOpen(newOpenState);
      setHasClickedSubmit(false);
    },
    children: _jsxs(Dialog.Panel, {
      children: [_jsx(Dialog.Heading, {
        children: "Add new student"
      }), _jsx(Dialog.Content, {
        children: _jsxs(Flex, {
          id: "ab-ansm-dialog-content",
          direction: "column",
          gap: 6,
          children: [hasFormError && _jsx(Notice, {
            intent: "negative",
            children: "Required information missing."
          }), isAdmin && _jsx(Field, {
            as: Switch,
            name: "blocked",
            label: "Blocked"
          }), _jsx(Text, {
            variant: "titleM",
            children: "Personal information"
          }), _jsx(Box, {
            children: showAutofillUpload ? _jsx(_Fragment, {
              children: _jsx(Field, {
                as: FileUpload,
                allowedFileTypes: ['.jpg', '.jpeg', '.png', '.pdf'],
                helpText: "Accepted file formats: PNG, PDF, JPG, and JPEG. Maximum file size 10MB.",
                label: "Autofill with passport",
                name: "passportFile",
                maxFileSize: 10000000 // 10 MB
                ,
                size: "sm",
                uploadFile: uploadFileCallback,
                children: _jsx(FileUpload.Button, {
                  children: "Browse files"
                })
              })
            }) : _jsxs(_Fragment, {
              children: [_jsx(Button, {
                onClick: function onClick() {
                  setShowAutofillUpload(true);
                },
                leadIcon: MagicWandFillIcon,
                intent: "primary",
                emphasis: "highlighted",
                children: "Autofill with passport"
              }), _jsx(HelpText, {
                children: "Auto-complete this section by uploading the student\u2019s passport. This is optional, but strongly recommended."
              })]
            })
          }), _jsxs(Flex, {
            gap: 4,
            children: [_jsx(Flex.Item, {
              grow: 1,
              children: _jsx(Field, {
                as: TextInput,
                name: "firstName",
                label: "First name",
                required: "Please enter a first name",
                validate: function validate(firstName) {
                  return validateMaxCharacterLength(firstName, 'First name');
                }
              })
            }), _jsx(Flex.Item, {
              grow: 1,
              children: _jsx(Field, {
                as: TextInput,
                name: "lastName",
                label: "Last name",
                required: "Please enter a last name",
                validate: function validate(lastName) {
                  return validateMaxCharacterLength(lastName, 'Last name');
                }
              })
            })]
          }), _jsx(Field, {
            as: TextInput,
            name: "middleName",
            label: "Middle name",
            validate: function validate(middleName) {
              return validateMaxCharacterLength(middleName, 'Middle name');
            }
          }), _jsx(Field, {
            as: DatePicker,
            name: "birthDate",
            maxDate: birthDateConstraints.max.toISOString(),
            minDate: birthDateConstraints.min.toISOString(),
            required: "Please enter a valid date of birth",
            label: "Date of birth",
            validate: createDatePickerValidator(birthDateConstraints.min, birthDateConstraints.max, 'day')
          }), _jsx(Field, {
            appearance: "native",
            as: Select,
            name: "countryOfCitizenship",
            label: "Country of citizenship",
            placeholder: "Please choose a country",
            required: "The country information is required to forward applications to our partners.",
            children: countriesOfCitizenshipList.map(function (opt) {
              return _createElement(Select.Option, _objectSpread(_objectSpread({}, opt), {}, {
                key: opt.value
              }));
            })
          }), _jsx(Field, {
            as: TextInput,
            name: "passportNumber",
            label: "Passport number",
            helpText: passportExpiryDateFieldValue ? 'Passport number is required if the expiry date is filled.' : 'Passport number is optional, but strongly recommended.',
            validate: function validate(passportNumber) {
              return validateMaxCharacterLength(passportNumber, 'Passport number', MAX_PASSPORT_INPUT_LIMIT);
            },
            required: passportExpiryDateFieldValue ? 'Passport number is required if the expiry date is filled.' : false
          }), _jsx(Field, {
            as: DatePicker,
            name: "passportExpiryDate",
            maxDate: passportExpiryDateConstraints.max.toISOString(),
            minDate: passportExpiryDateConstraints.min.toISOString(),
            label: "Passport expiry date",
            required: passportNumberFieldValue ? 'The passport expiry date is required if the passport number is filled.' : false
          }), _jsx(Field, {
            as: RadioGroup,
            label: "Gender",
            name: "gender",
            children: _jsxs(Flex, {
              gap: 8,
              direction: "row",
              children: [_jsx(RadioGroup.Option, {
                label: "Male",
                value: "male"
              }), _jsx(RadioGroup.Option, {
                label: "Female",
                value: "female"
              })]
            })
          }), _jsx(Text, {
            variant: "titleM",
            children: "Contact information"
          }), _jsx(Field, {
            as: TextInput,
            name: "email",
            label: "Email",
            required: "Please provide a valid email address. ApplyBoard will not communicate with the student.",
            helpText: "Please provide a valid and actively monitored email address for the student. ApplyBoard will not communicate with the student.",
            validate: function validate(email) {
              return monolithEmailValidation(email) ? true : 'Email is invalid';
            }
          }), _jsx(Field, {
            as: TextInput,
            name: "phoneNumber",
            label: "Phone number",
            validate: function validate(phoneNumber) {
              var trimmedPhoneNumber = phoneNumber.trim();
              if (trimmedPhoneNumber.length > 0 && trimmedPhoneNumber.length < MIN_PHONE_NUMBER_LENGTH) {
                return "Phone number is too short (min ".concat(MIN_PHONE_NUMBER_LENGTH, " characters)");
              }
              if (/[a-zA-Z]/.test(trimmedPhoneNumber)) {
                return "Phone number can not contain letters";
              }
              return validateMaxCharacterLength(trimmedPhoneNumber, 'Phone number');
            }
          }), _jsx(Text, {
            variant: "titleM",
            children: "Lead management"
          }), _jsx(Field, {
            appearance: "native",
            as: Select,
            name: "leadStatus",
            label: "Status",
            placeholder: "Please choose a status",
            children: leadStatusList.map(function (opt) {
              return _createElement(Select.Option, _objectSpread(_objectSpread({}, opt), {}, {
                key: opt.value
              }));
            })
          }), _jsx(Field, {
            appearance: "native",
            as: Select,
            name: "leadSource",
            label: "Referral Source",
            placeholder: "Please choose a referral source",
            children: leadSourcesList.map(function (opt) {
              return _createElement(Select.Option, _objectSpread(_objectSpread({}, opt), {}, {
                key: opt.value
              }));
            })
          }), _jsx(CustomReferralField, {}), _jsx(Field, {
            as: MultiCombobox,
            leadIcon: SearchOutlineIcon,
            name: "countryOfInterest",
            intent: "secondary",
            label: "Country of Interest",
            "aria-label": "Country of Interest",
            children: markets.map(function (option) {
              return _jsx(MultiCombobox.Option, {
                label: option.displayName,
                value: option.id
              }, option.id);
            })
          }), _jsx(Field, {
            as: MultiCombobox,
            leadIcon: SearchOutlineIcon,
            name: "servicesOfInterest",
            intent: "secondary",
            label: "Services of Interest",
            "aria-label": "Services of Interest",
            children: SERVICE_OF_INTEREST_DATA.map(function (option) {
              return _jsx(MultiCombobox.Option, {
                label: option.label,
                value: option.value.toString()
              }, option.value);
            })
          }), _jsx(Field, {
            as: Checkbox,
            name: "didStudentConsent",
            label: _jsxs(Text, {
              variant: "bodyS",
              children: ["I confirm that I have received express written consent from the student whom I am creating this profile for and I can provide proof of their consent upon request. To learn more please refer to the", ' ', _jsx("a", {
                href: "https://applyboardindia.zendesk.com/hc/en-us/articles/6478382982541",
                rel: "noopener noreferrer",
                target: "_blank",
                children: "Personal Data Consent/Confirm Visa+Enrolment"
              }), ' ', "article."]
            }),
            required: "This is a required field."
          }), _jsx(StudentConsentErrorLabel, {
            hasClickedSubmit: hasClickedSubmit
          }), _jsxs(Flex, {
            gap: 1,
            children: [_jsx(Text, {
              variant: "bodyS",
              intent: "negative",
              as: "span",
              children: "*"
            }), _jsx(Text, {
              variant: "bodyS",
              contrast: "mid",
              children: "Required information."
            })]
          })]
        })
      }), _jsxs(Dialog.Actions, {
        children: [_jsx(Dialog.CloseButton, {
          width: "fill",
          children: "Cancel"
        }), _jsx(Button, {
          disabled: isSubmittingStudentProfile,
          intent: "primary",
          width: "fill",
          type: "submit",
          onClick: function onClick() {
            setHasClickedSubmit(true);
          },
          children: "Add student"
        })]
      })]
    })
  });
};
function getBrowserTimezone(dateInput) {
  return dateInput.toLocaleDateString(undefined, {
    day: '2-digit',
    timeZoneName: 'short'
  }).slice(4);
}